/*
 * @Author: MR.Wang
 * @Date:   2017-06-27 10:35:31
 * @Last Modified by:   MR.Wang
 * @Last Modified time: 2017-07-05 15:09:56
 */

'use strict'

let vae_extended = {}
let u = navigator.userAgent
const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
const ENV_DEV = process.env.NODE_ENV === 'development'
import wx from 'weixin-js-sdk';
import * as Api from "@/api/activity/wx_share.js";

vae_extended.install = function(Vue, options) {
  Vue.prototype.isAndroid = isAndroid
  Vue.prototype.isIOS = isIOS
  //  混合 包括全局路由控制的响应逻辑等
  Vue.mixin({
    created() {
      //  this.showCerNo = false;
    },
    //  全局路由钩子，非详情页，禁用分享，更新tigutle
    beforeRouteLeave(to, from, next) {
      next(nv => {
        // this.$share(false)
      })
    }
  })

  //  路由跳转
  Vue.prototype.$pageTo = function(url) {

  }


 
  //  支付
  Vue.prototype.$pay = function(data) {

  }

  //  刷新页面
  Vue.prototype.$reloadPage = function() {
    location.reload()
  }

  //  更新标题
  Vue.prototype.$updateTitle = function() {

  }

  //  隐藏分享按钮
  Vue.prototype.$hideShare = function() {
    // this.share()
  }
  
  Vue.prototype.$share = function(dataShare, status) {
      if (!dataShare&&!dataShare.share_open) return false
      //分享开始
      var imgUrl = dataShare.share_logo;
      var lineLink = dataShare.share_link;
      var descContent = dataShare.share_content;
      var descContentqq = dataShare.share_content_qq;
      var shareTitle = dataShare.share_title;
      var qqshareTitle = dataShare.share_title_qq;
      var wxshareTitle = dataShare.share_title_wx;
      
      if(!wxshareTitle){
        wxshareTitle = dataShare.share_title;
      }
      
      if(!qqshareTitle){
        qqshareTitle = dataShare.share_title;
      }

      if(!descContentqq){
          descContentqq = descContent;
      }

      wx.config({
          appId: dataShare.share_open.AppID,
          timestamp: dataShare.share_open.timestamp,
          nonceStr: dataShare.share_open.nonceStr,
          signature: dataShare.share_open.signature,
          debug: false,
          jsApiList: [
              // 所有要调用的 API 都要加到这个列表中
            //  'onMenuShareTimeline', //分享到朋友圈  -->快废弃
             // 'onMenuShareAppMessage', //分享给朋友  -->快废弃
              'hideAllNonBaseMenuItem',
             // 'onMenuShareQQ', //分享到QQ            -->快废弃
              'onMenuShareWeibo', //分享到腾讯微博
              //'onMenuShareQZone', //分享到QQ空间      -->快废弃
              'updateAppMessageShareData' ,//“分享给朋友”及“分享到QQ”
              'updateTimelineShareData' ,//“分享到朋友圈”及“分享到QQ空间”
          ]
      });

      function shareCallbac() {
           //alert(1);
          //  $(".shade").hide();
      }
      if (status) {
          wx.ready(function() {
              wx.hideAllNonBaseMenuItem()
          })
          return false
      }
      wx.ready(function() {
          // alert('成功了')
          // 在这里调用 API
/*          wx.onMenuShareTimeline({
              title: wxshareTitle, // 分享标题
              link: lineLink, // 分享链接
              imgUrl: imgUrl, // 分享图标
              success: function() {
                  shareCallbac();
              },
              cancel: function() {
                  shareCallbac();
              }
          });
          wx.onMenuShareQQ({
              title: qqshareTitle, // 分享标题
              desc: descContentqq, // 分享描述
              link: lineLink, // 分享链接
              imgUrl: imgUrl, // 分享图标
              success: function() {
                  shareCallbac();
              },
              cancel: function() {
                  shareCallbac();
              }
          });
            wx.onMenuShareQZone({
              title: qqshareTitle, // 分享标题
              desc: descContentqq, // 分享描述
              link: lineLink, // 分享链接
              imgUrl: imgUrl, // 分享图标
              success: function() {
                  shareCallbac();
              },
              cancel: function() {
                  shareCallbac();
              }
          });
          */
          //“分享给朋友”及“分享到QQ”
          wx.updateAppMessageShareData({
              title: qqshareTitle, // 分享标题
              desc: descContentqq, // 分享描述
              link: lineLink, // 分享链接
              imgUrl: imgUrl, // 分享图标
              type: '', // 分享类型,music、video或link，不填默认为link
              dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
              success: function() {
                  shareCallbac();
                  //alert(lineLink);
              },
              cancel: function() {
                  shareCallbac();
              }
          });
          //“分享到朋友圈”及“分享到QQ空间”
          wx.updateTimelineShareData({
              title: wxshareTitle, // 分享标题
              desc: descContentqq, // 分享描述
              link: lineLink, // 分享链接
              imgUrl: imgUrl, // 分享图标
              type: '', // 分享类型,music、video或link，不填默认为link
              dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
              success: function() {
                  shareCallbac();
                  //alert(lineLink);
              },
              cancel: function() {
                  shareCallbac();
              }
          });
          //分享到腾讯微博
          wx.onMenuShareWeibo({
              title: shareTitle, // 分享标题
              desc: descContent, // 分享描述
              link: lineLink, // 分享链接
              imgUrl: imgUrl, // 分享图标
              success: function() {
                  shareCallbac();
              },
              cancel: function() {
                  shareCallbac();
              }
          });
      });
      // wx.error(function(res) {
      //     console.log(res)
      //     // alert('失败啦')
      // })
      //分享结束
  }
  //  更新标题
  Vue.prototype.$updateTitle = function(title, img) {
      if (title === undefined || window.document.title === title) {
          return
      }
      document.title = title
      var mobile = navigator.userAgent.toLowerCase()
      // 兼容性判断
      if (/iphone|ipad|ipod/.test(mobile)) {
          // 创建空的 iframe，触发 onload 事件
          var iframe = document.createElement('iframe')
          iframe.style.display = 'none'
          // 替换成站标favicon路径或者任意存在的较小的图片即可
          iframe.setAttribute('src', img || 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7')
          // onload 回调函数
          var iframeCallback = function() {
              setTimeout(function() {
                  // 卸磨杀驴
                  iframe.removeEventListener('load', iframeCallback)
                  document.body.removeChild(iframe)
              }, 0)
          }
          // 定义事件
          iframe.addEventListener('load', iframeCallback)
          document.body.appendChild(iframe)
      }

  }
  // 重置滚动条
  Vue.prototype.$refresh = (dom) => {
    this.timer && window.clearTimeout(this.timer)
    this.timer = window.setTimeout(() => {
      dom.refresh()
    }, 500)
  }
}
export default vae_extended
